import React, { useState } from 'react';
import '../Contact/contact.css'; 
import Footer from '../Footer/Footer'; 

const Contact = () => {
  
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: ''
  });

  
  const [successMessage, setSuccessMessage] = useState('');

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault(); 

    try {
      const response = await fetch('https://pkrealestateapi.onrender.com/contact/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Success:', data);
        setSuccessMessage('Submitted successfully!');
        setFormData({ first_name: '', last_name: '', email: '', phone: '', message: '' }); // Reset form
      } else {
        throw new Error('Failed to submit');
      }
    } catch (error) {
      console.error('Error:', error);
      setSuccessMessage('Failed to send. Please try again later.');
    }
  };

  return (
    <div>
      <section className="section__container contact__container" id="contact">
          <div className="contact__image"></div> 
        
        
        
          <div className="contact__content">
            <h2 className="section__header">Contact Us</h2>
            <h3 className="section__subheader">Book your dream property today!</h3>
            <p className="section__subheader">
              Let’s start this exciting journey together!
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form__group">
                <input name="first_name" type="text" placeholder="First Name" value={formData.first_name} onChange={handleChange} required />
                <input name="last_name" type="text" placeholder="Last Name" value={formData.last_name} onChange={handleChange} required />
              </div>
              <div className="form__group">
                <input name="email" type="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                <input name="phone" type="number" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
              </div>
              <textarea name="message" cols="30" rows="5" placeholder="Description" value={formData.message} onChange={handleChange} required></textarea>
              <button type="submit">SUBMIT</button>
            </form>

            {successMessage && (
              <div id="success-message">
                <p>{successMessage}</p>
              </div>
            )}
          </div>
       
      </section>

      
      <Footer />
    </div>
  );
};

export default Contact;